import { render, staticRenderFns } from "./BranchPerformanceReport.vue?vue&type=template&id=562a636d&"
import script from "./BranchPerformanceReport.vue?vue&type=script&lang=js&"
export * from "./BranchPerformanceReport.vue?vue&type=script&lang=js&"
import style0 from "./BranchPerformanceReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports